const ROUTER = {
  // admin
  adminHome: '/bang-dieu-khien',
  profile: '/tai-khoan',
  orderTracking: "/theo-doi-don-van",
  orderCreate: "/tao-don-hang",
  historyChangeWeigth: "/lich-su-dieu-chinh-khoi-luong",
  orderChangeWeight: "/don-dieu-chinh-khoi-luong",
  customerSupport:"/ho-tro-khach-hang",
  orderHistory:"/lich-su-don-van",
  manageProduct:"/quan-ly-san-pham",
  finacialReport:"/bao-cao-tai-chinh",
  escrowHisotry:"/lich-su-ky-quy",
  exportPdf:"/xuat-file-pdf",
  reconciliationHistory:"/lich-su-doi-soat",
  transactionHistory:"/lich-su-giao-dich",
  // public
}

export default ROUTER
